var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#59CBE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6667 19.1099V19.3349H14.3333V19.1016C14.3333 17.7854 13.8668 17.2968 13.0957 16.4891L13.0933 16.4866L12.9758 16.3632C12.2383 15.5949 11.8333 14.5782 11.8333 13.5016C11.8333 12.2382 12.3942 11.0574 13.3717 10.2624C14.3492 9.46741 15.635 9.16408 16.8983 9.42658C18.5025 9.75741 19.7858 11.0707 20.09 12.6941C20.3258 13.9716 19.9833 15.2607 19.1525 16.2282C19.0571 16.3379 18.9653 16.4393 18.8783 16.5355L18.8782 16.5356L18.79 16.6332L18.7898 16.6334C18.1374 17.3483 17.6667 17.8642 17.6667 19.1099ZM13.5 20.1682H18.5V19.1099C18.5 18.1875 18.8024 17.8558 19.4048 17.1952L19.405 17.1949L19.4368 17.16L19.4369 17.1599C19.5452 17.0409 19.6604 16.9143 19.7825 16.7732C20.7808 15.6124 21.1917 14.0699 20.91 12.5416C20.5425 10.5891 18.9992 9.00908 17.0675 8.60991C15.5592 8.29575 14.0183 8.66241 12.8458 9.61575C11.6733 10.5699 11 11.9866 11 13.5016C11 14.7941 11.4883 16.0157 12.3725 16.9391L12.4908 17.0616L12.4922 17.063C13.2253 17.8311 13.5 18.1189 13.5 19.1016V20.1682ZM12.6667 13.5016H13.5C13.5 12.1232 14.6217 11.0016 16 11.0016V10.1682C14.1617 10.1682 12.6667 11.6632 12.6667 13.5016ZM18.5 21.8349V21.0016H13.5V21.8349H18.5ZM18.5 22.6682V23.5016H13.5V22.6682H18.5Z",
    fill: "#2C2A29"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IconInfo.436c535decfcccc747a48e53b31e8650.svg";